<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'dialogs.cashRegister.closeTitle' | translate }}</h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <ng-container *ngIf="!init">

            <div class="loading-spinner-wrapper">
                <mat-spinner class="loading-spinner" [diameter]="50"></mat-spinner>
            </div>

        </ng-container>

        <u2b-message type="info">
            <span [innerHTML]="'dialogs.cashRegister.closeCashInfoHtml' | translate : { title: cashRegister?.title }"></span>
        </u2b-message>

        <ng-container *ngIf="formGroup">
            <form [formGroup]="formGroup" class="mt-24">

                <div class="mb-16">
                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>{{ 'dialogs.cashRegister.closeTargetBalanceLabel' | translate }}</mat-label>
                        <input type="number" step="0.01" matInput data-test="FI-Aktueller SOLL Kassenbestand"
                               formControlName="targetCash">
                        <mat-error>{{ formGroup.get('targetCash').errors | firstErrorMessage }}</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>{{ 'dialogs.cashRegister.closeActualBalanceLabel' | translate }}</mat-label>
                        <input type="number" step="0.01" matInput data-test="FI-Aktueller IST Kassenbestand"
                               formControlName="actualCash">
                        <mat-error>{{ formGroup.get('actualCash').errors | firstErrorMessage }}</mat-error>
                    </mat-form-field>

                    <ng-container *ngIf="differenceSum !== 0">
                        <mat-form-field appearance="outline" style="width: 100%">
                            <mat-label>{{ 'dialogs.cashRegister.closeDifferenceReasonLabel' | translate }}</mat-label>
                            <textarea matInput data-test="FTGrund für Differenz"
                                      formControlName="differenceReason"
                                      rows="3"
                                      autocomplete="new-password"></textarea>
                            <mat-hint>{{ 'dialogs.cashRegister.closeDifferenceAmountHint' | translate }} <b>{{ differenceSum | bcmDynamicCurrency }}</b>
                            </mat-hint>
                            <mat-error>{{ formGroup.get('differenceReason').errors | firstErrorMessage }}</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <mat-divider class="special-divider"></mat-divider>

                    <div>
                        <mat-checkbox formControlName="cashAddEnabled">
                            {{ 'dialogs.cashRegister.closeDepositQuestion' | translate }}
                        </mat-checkbox>

                        <ng-container *ngIf="formGroup.get('cashAddEnabled').value">
                            <mat-form-field appearance="outline" class="mt-16" style="width: 100%">
                                <mat-label>{{ 'dialogs.cashRegister.closeDepositLabel' | translate }}</mat-label>
                                <input type="number" step="0.01" matInput data-test="FI-Betrag, der eingelegt wird"
                                       formControlName="cashAdd">
                                <mat-hint>{{ 'dialogs.cashRegister.closeBalanceAfterChange' | translate }}
                                    <b>{{ (formGroup.get('actualCash').value + formGroup.get('cashAdd').value - formGroup.get('cashLift')?.value) | bcmDynamicCurrency }}</b>
                                </mat-hint>
                                <mat-error>{{ formGroup.get('cashAdd').errors | firstErrorMessage }}</mat-error>
                            </mat-form-field>
                        </ng-container>
                    </div>

                    <mat-divider class="special-divider"></mat-divider>

                    <div>
                        <mat-checkbox formControlName="cashLiftEnabled">
                            {{ 'dialogs.cashRegister.closeWithdrawQuestion' | translate }}
                        </mat-checkbox>

                        <ng-container *ngIf="formGroup.get('cashLiftEnabled').value">
                            <mat-form-field appearance="outline" class="mt-16" style="width: 100%">
                                <mat-label>{{ 'dialogs.cashRegister.closeWithdrawLabel' | translate }}</mat-label>
                                <input type="number" step="0.01" matInput
                                       data-test="FI-Betrag, der abgeschöpft wird"
                                       formControlName="cashLift">
                                <mat-hint>{{ 'dialogs.cashRegister.closeBalanceAfterChange' | translate }}
                                    <b>{{ (formGroup.get('actualCash').value + formGroup.get('cashAdd')?.value - formGroup.get('cashLift').value) | bcmDynamicCurrency }}</b>
                                </mat-hint>
                                <mat-error>{{ formGroup.get('cashLift').errors | firstErrorMessage }}</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="mt-16" style="width: 100%">
                                <mat-label>{{ 'dialogs.cashRegister.closeWithdrawReasonLabel' | translate }}</mat-label>
                                <textarea matInput formControlName="cashLiftReason"
                                          data-test="FTA-Grund der Abschöpfung"
                                          rows="3"></textarea>
                            </mat-form-field>
                        </ng-container>
                    </div>

                    <mat-divider class="special-divider"></mat-divider>

                </div>

            </form>
        </ng-container>

        <ng-container
                *ngIf="differenceSum === 0 || formGroup.get('differenceReason').valid; else showDifferenceError">
            <u2b-message type="success">
                <span [innerHTML]="'dialogs.cashRegister.closeZReportInfoHtml' | translate"></span>
            </u2b-message>
        </ng-container>
        <ng-template #showDifferenceError>
            <u2b-message type="error">
                <span [innerHTML]="'dialogs.cashRegister.closeDifferenceMismatchHtml' | translate : { amount: (differenceSum | bcmDynamicCurrency) }"></span>
            </u2b-message>
        </ng-template>


    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">
        <button data-test="B-Abbrechen" mat-button
                (click)="dialogRef.close(false)"
                [attr.aria-label]="'common.closeDialogAria' | translate">
            <mat-icon>cancel</mat-icon>
            {{ 'common.cancel' | translate }}
        </button>
        <button data-test="B-Kasse schließen (Tagesabschluss)" mat-flat-button
                color="accent"
                (click)="closeCashRegister()"
                class="save-button mat-accent"
                [disabled]="!formGroup.valid || isLoading || !init"
                [attr.aria-label]="'dialogs.cashRegister.closeButtonAria' | translate">
            <mat-icon>point_of_sale</mat-icon>
            <span>{{ 'dialogs.cashRegister.closeButton' | translate }}</span>
            <ng-container *ngIf="isLoading">
                <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
            </ng-container>
        </button>
    </div>

</div>
